import { render } from "./DummyData.vue?vue&type=template&id=6bc39698"
import script from "./DummyData.vue?vue&type=script&lang=js"
export * from "./DummyData.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__